<template>
  <kst-table action paginated view-mode
    :data="items"
    :selected.sync="userData.selected"
  >
    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-image"
      field="DispatchImageSrc"
      :label="InvoiceItemCatalog.DispatchImageSrc.Label"
    >
      <kst-image read-only thumbnail :src="row[column.field]"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      field="DispatchID"
      :label="InvoiceItemCatalog.Name.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="InvoiceItemCatalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-sku"
      field="SKU"
      :label="InvoiceItemCatalog.SKU.Label"
    >
      <kst-value ellipsis :field="column.field" :data="row" :catalog="InvoiceItemCatalog"/>
    </b-table-column>

    <b-table-column numeric
      v-slot="{ column, row }"
      cell-class="ks-col-qty"
      field="QtyAvailable"
      :label="InvoiceItemCatalog.QtyAvailable.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="InvoiceItemCatalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-packaging"
      field="Packaging"
      :label="InvoiceItemCatalog.Packaging.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="InvoiceItemCatalog"/>
    </b-table-column>

    <b-table-column numeric
      v-slot="{ column, row }"
      cell-class="ks-col-price"
      field="SellPrice"
      :label="InvoiceItemCatalog.SellPrice.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="InvoiceItemCatalog"/>
    </b-table-column>
  </kst-table>
</template>

<script>
import InvoiceItemCatalog from "../InvoiceItemCatalog.js";

export default {
  props: {
    items: Array,
    userData: Object
  },
  data: () => ({
    InvoiceItemCatalog: InvoiceItemCatalog
  })
}
</script>